<op-principal
  class="op-principal-list--principal"
  *ngFor="let principal of principals"
  [hideName]="true"
  [principal]="principal"
  [link]="false"
  size="mini"
></op-principal>
